/*
 *
 * User actions
 *
 */
import { EventTypes } from 'redux-segment';
import {
  FETCH_USER,
  FETCH_USER_FAILED,
  FETCH_USER_SUCCESS,
  FETCH_USER_SUCCESS_SEGMENT,
} from './constants';

export function fetchUser() {
  return {
    type: FETCH_USER,
  };
}

export function fetchUserSuccess(userDetails) {
  return {
    type: FETCH_USER_SUCCESS,
    userDetails,
  };
}

export function fetchUserSuccessSegment(userDetails = {}) {
  const { id: userId, email, isProdegeUser = false } = userDetails;

  const segmentUpdate = {};
  if (email && userId) {
    segmentUpdate.meta = {
      analytics: {
        eventType: EventTypes.identify,
        eventPayload: {
          userId,
          traits: {
            email,
            id: userId,
            isProdegeUser,
          },
        },
      },
    };
  }

  return {
    type: FETCH_USER_SUCCESS_SEGMENT,
    ...segmentUpdate,
  };
}

export function fetchUserError(error) {
  return {
    type: FETCH_USER_FAILED,
    error,
  };
}
